export default {
    data() {
        return {
            check_umu_role: [],
            checkAdminRole: [],
        }
    }
}